export default __webpack_public_path__ + "static/media/OTBUpdate.598813ae.png";